export default class User {
  constructor(username, email, password) {
    this.username = username;
    this.email = email;
    this.password = password;
    this.first_name = "";
    this.last_name = "";
    this.organization_id = null;
    this.consens = [];
    this.langs = [{ id: "it", description: "Italiano" }];
    this.userType = null;
    this.code = null;
    this.role = null;
    this.id = null;
  }
}
